import { CircularProgress, List, ListItem, Typography } from "@mui/material";
import { useUserProfileStore } from "../../App/State/Stores/UserProfileStore";
import { IImportStatus } from "../../App/Typings/Imports";
import { getImportStatusTypeDisplay } from "../Imports";

export const ImportStatusDetails = ({
  status,
  isFetching,
}: {
  status?: IImportStatus;
  isFetching: boolean;
}) => {
  const { getUserAdjustedDate } = useUserProfileStore();

  if (!status) {
    return <></>;
  }

  const hasAttachments = !!status.zipFileName;

  let detailList = [
    {
      title: "Status:",
      data: status.status ? getImportStatusTypeDisplay(status.status) : "",
    },
    {
      title: hasAttachments ? "File Names:" : "File Name:",
      data: hasAttachments ? (
        <>
          {status.fileName}
          <br />
          {status.zipFileName}
        </>
      ) : (
        status.fileName
      ),
    },
    {
      title: "Uploaded By:",
      data: status.username ?? "",
    },
    {
      title: "Uploaded Date:",
      data: getUserAdjustedDate(status.createdDate).format("LLL"),
    },
    {
      title: "Total Rows:",
      data: isFetching ? <CircularProgress size={20} /> : status.totalRows,
    },
  ];

  return (
    <List
      data-test="import-information"
      sx={{
        justifySelf: "flex-start",
        width: "auto",
        marginRight: "auto",
        justifyContent: "center",
        display: "inline-grid",
        gridTemplateColumns: {
          xs: "1fr 1fr",
          sm: "repeat(5, max-content)",
          md: "max-content",
          lg: "repeat(3, max-content)",
          xl: "repeat(5, max-content)",
        },
        columnGap: { xs: 1, sm: 4, xl: 8 },
        rowGap: { xs: 1, sm: 2 },
      }}
    >
      {detailList.map((data) => (
        <ListItem key={data.title} sx={{ display: "block", p: 0 }}>
          <Typography sx={{ fontWeight: "normal" }}>{data.title}</Typography>
          <Typography sx={{ fontWeight: "bold" }}>{data.data}</Typography>
        </ListItem>
      ))}
    </List>
  );
};
